import { useCallback, useMemo } from "react";

import type { DayOfTheWeek, InputMaybe } from "@/lib/gql/__generated__/graphql";

import type { ForArrayType } from "@/components/features/_model/types/auto-generator-for-view-model";

import type { FormOptionType } from "@/components/ui/form/_types/type";

type Props = {
	checkInAvailableDayOfTheWeek: ForArrayType<InputMaybe<DayOfTheWeek[]> | undefined> | undefined;
	onSetViewModel: (
		values: {
			key: "checkInAvailableDayOfTheWeek";
			value: ForArrayType<DayOfTheWeek[]>;
		}[],
	) => void;
};

export const useCheckInAvailableDayOfTheWeek = ({ checkInAvailableDayOfTheWeek, onSetViewModel }: Props) => {
	const rawCheckInAvailableDayOfTheWeek = useMemo(
		() => checkInAvailableDayOfTheWeek?.value?.map((dayOfTheWeek) => dayOfTheWeek.value) ?? [],
		[checkInAvailableDayOfTheWeek],
	);

	const onSetCheckInAvailableDayOfTheWeek = useCallback(
		(input: FormOptionType) => {
			const dayOfTheWeek = input.value as DayOfTheWeek;

			const newRawCheckInAvailableDayOfTheWeek = rawCheckInAvailableDayOfTheWeek?.includes(dayOfTheWeek)
				? rawCheckInAvailableDayOfTheWeek.filter((item) => item !== dayOfTheWeek)
				: rawCheckInAvailableDayOfTheWeek?.length
					? [...rawCheckInAvailableDayOfTheWeek, dayOfTheWeek]
					: [dayOfTheWeek];

			const newCheckInAvailableDayOfTheWeek = {
				isEdited: true,
				hasError: false,
				value: newRawCheckInAvailableDayOfTheWeek?.map((dayOfTheWeek) => {
					return {
						isEdited: true,
						value: dayOfTheWeek,
					};
				}),
			};

			onSetViewModel([
				{
					key: "checkInAvailableDayOfTheWeek",
					value: newCheckInAvailableDayOfTheWeek,
				},
			]);
		},
		[onSetViewModel, rawCheckInAvailableDayOfTheWeek],
	);

	return {
		checkInAvailableDayOfTheWeek,
		rawCheckInAvailableDayOfTheWeek,
		onSetCheckInAvailableDayOfTheWeek,
	};
};
